interface InstituitionLogoProps {
  imageURL?: string
  width?: number
  height?: number
  alt?: string
}

export const InstituitionLogo = ({
  imageURL,
  width,
  height,
  alt = 'Logo da Instituição'
}: InstituitionLogoProps) => {
  return (
    <div style={{ height: `${height}px` }}>
      <img src={imageURL} width={width} height={height} alt={alt} />
    </div>
  )
}
